export const FIELD_LABEL_CUSTOMER_NUMBER = 'Customer Number'
export const FIELD_LABEL_CUSTOMER_NAME = 'Name'
export const FIELD_LABEL_CUSTOMER_ADDRESS = 'Address'
export const FIELD_NAME_CUSTOMER_NUMBER = 'tapcustomerId'
export const FIELD_NAME_CUSTOMER_NAME = 'name'
export const FIELD_NAME_CUSTOMER_ADDRESS = 'customerAddresses'
export const ENABLE_V2_REQUEST_NEW_DISTRIBUTOR = true
